<template>
  <div class="container-fluid mt-5">
    <h3>身份驗證有誤，請先登出後再重新登入健檢問卷管理系統，謝謝。</h3>
  </div>
</template>
<script setup>

</script>